import React, { useMemo } from "react";
import { Image } from "../../../client/api";

type EmblemImageProps = {
  image?: Image | null;
  imageUrl?: string | null;
  width: number;
  className?: string;
  alt?: string;
  round?: boolean;
};

const EmblemImage: React.FC<EmblemImageProps> = ({ image, imageUrl, width, className, alt, round }) => {
  const cloudflareWidth = useMemo(() => width < 128 ? 128 : width < 512 ? 512 : width < 1080 ? 1080 : 1920, [width]);
  const chosenUrl = useMemo(() => {
    if (imageUrl) {
      if (imageUrl.indexOf("/public") === -1) return imageUrl;
      return `${imageUrl.replace("/public", "")}/w=${cloudflareWidth}`;
    }
    if (image?.url) {
      if (image.url.indexOf("/public") === -1) return image.url;
      return `${image.url.replace("/public", "")}/w=${cloudflareWidth}`;
    }
    return undefined;
  }, [cloudflareWidth, imageUrl, image]);
  // noinspection JSSuspiciousNameCombination
  const containerStyle = useMemo(() => ({
    width,
    height: width
  }), [width]);
  const imageStyle = useMemo(() => ({
    ...(round ? { borderRadius: "50%" } : {})
  }), [round]);
  if (!chosenUrl) {
    return <div className={`w-full h-full bg-bg-secondary dark:bg-bg-secondary-dark ${className ?? ""}`}
                style={{ width, aspectRatio: 1 }} />;
  }

  return (
    <div
      className={`flex items-center justify-center bg-transparent ${className ?? ""}`}
      style={containerStyle}
    >
      <img
        src={chosenUrl}
        alt={alt ?? "Team emblem"}
        className="w-full h-full object-contain"
        style={imageStyle}
      />
    </div>
  );
};

export default EmblemImage;






